const transitionRedirect = () => {
    const location = document.location;
    let path = location.pathname.split('/');
    const params = new URLSearchParams(location.search);
    const isSigninPage = path.length == 4 && path[3] == 'signin';
    const ishelpCenterPath = path.length == 2 && path[1] == 'help_center';
    const isErrorPage = document.querySelectorAll('.error-page').length > 0;

    if (ishelpCenterPath) {
        window.location.replace('/hc/en-us');
        return false;
    }

    // Do nothing if we are not on an error page og a signin page
    if (!isErrorPage && !isSigninPage) {
        return false;
    }

    // This is to handle redirects to signin if the article is not visible to the user
    if (isSigninPage && params.has('return_to')) {
        path = params.get('return_to')?.split('/').slice(2) || [];
    }

    // Do nothing if our path does not match the required length
    if (path.length != 5) {
        return false;
    }

    const space = path[3];
    const sourceId = path[4].split(/-|\?/).shift() || '';

    const assetsMappingsElement = document.createElement('script');
    assetsMappingsElement.onload = () => {
        const mapping = window.getRedirectMappings();

        let targetSpaceId: string = mapping[space][sourceId];
        if (targetSpaceId) {
            if (typeof targetSpaceId === 'number') {
                targetSpaceId = `${space}/${targetSpaceId}`;
            }

            const newLocation = `https://${location.host}/${path[1]}/${path[2]}/${targetSpaceId}`;

            window.location.replace(newLocation);
        }
    };
    // In header.hbs, the template defineds a global variable `assetsMappings` which is the js link defined getRedirectMappings()
    assetsMappingsElement.src = window.assetsMappings;

    document.head.appendChild(assetsMappingsElement);
};

export default transitionRedirect;
